import dynamic from "next/dynamic";

const SignInPage = dynamic(() => import("@/components/page/auth/SignInTemplate"), { ssr: false });

export default SignInPage;

export const getServerSideProps = async () => ({
  props: { noHeader: true },
});
